<template>
  <div class="page-inner r" style="min-height: 100vh;">
    <div class="page-title">
      <h3>{{ $t("message.Категории") }}</h3>
      <div class="page-breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">{{ $t("message.Главная") }}</router-link>
          </li>
          <li class="active breadcrumb-item">{{ $t("message.Категории") }}</li>
        </ol>
      </div>
    </div>
    <div id="main-wrapper" v-if="!hasReadPermissions">
      {{ $t("message.Нет_прав_доступа_на_чтение") }}
    </div>
    <div id="main-wrapper" v-if="hasReadPermissions">
      <b-button
        :disabled="!hasUpdatePermissions"
        :variant="'success'"
        class="mb-1 float-right"
        @click="addRow()"
      >
        {{ $t("message.Добавить_категорию") }}
      </b-button>
      <b-table
        id="category-table"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :sort-by.sync="sortBy"
      >
        <template slot="sort_order" slot-scope="row">
          <div
            v-show="order_update_id != row.item.id"
            @click.stop="updateOrder(row.item)"
            style="width:65px;cursor:text;text-align:center;border-bottom: 1px dotted #999;"
          >
            {{ row.item.sort_order }}
          </div>
          <input
            v-show="order_update_id == row.item.id"
            v-focus="order_update_id == row.item.id"
            v-model="row.item.sort_order"
            v-on:blur="saveOrder(row.item)"
            @keyup.enter="saveOrder(row.item)"
            style="width:65px"
          />
        </template>

        <template slot="image_url" slot-scope="data">
          <img :src="data.item.image_url" :width="64" />
        </template>
        <template slot="extended" slot-scope="data">
          <i
            class="fa fa-check"
            aria-hidden="true"
            v-if="data.item.extended == true"
          ></i>
          <i
            class="fa fa-ban"
            aria-hidden="true"
            v-if="data.item.extended == false"
          ></i>
        </template>

        <template slot="actions" slot-scope="row">
          <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
          <b-button
            size="sm"
            @click.stop="viewChannels(row.item, row.index, $event.target)"
            class="mr-1"
          >
            <i class="fas fa-eye"></i>
          </b-button>
          <b-button
            :disabled="!hasUpdatePermissions"
            size="sm"
            @click.stop="editRow(row.item, row.index, $event.target)"
            class="mr-1"
          >
            <i class="fas fa-edit"></i>
          </b-button>
          <b-button
            :disabled="!hasUpdatePermissions"
            size="sm"
            @click.stop="deleteRow(row.item, row.index, $event.target)"
          >
            <i class="fas fa-trash-alt"></i>
          </b-button>
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalRows"
        :per-page="perPage"
        v-model="currentPage"
      ></b-pagination>

      <b-modal
        id="categoryModalInfo"
        @hide="resetModal"
        :ok-title="$t('message.Сохранить')"
        :cancel-title="$t('message.Отмена')"
        :title="$t('message.Категории_-_Редактирование')"
        modal-ok
        modal-cancel
        @ok="handleOk"
        no-close-on-esc
        no-close-on-backdrop
      >
        <CategoryForm :model="categoryModel"></CategoryForm>
      </b-modal>
      <b-modal
        id="modalChannels"
        :ok-title="$t('message.Закрыть')"
        :title="$t('message.Список_каналов_-_Просмотр')"
        ok-only
        size="lg"
      >
        <ChannelsListForm
          :model="categoryModelChannels"
          :type="'categories'"
        ></ChannelsListForm>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import CategoryForm from "./CategoriesForm";
import ChannelsListForm from "./ChannelListForm";
import debounce from "./stolencrap/index";
import { focus } from "vue-focus";

export default {
  name: "Categories",
  components: {
    CategoryForm,
    ChannelsListForm
  },
  data() {
    return {
      isBusy: false,
      sortBy: "sort_order",
      fields: [
        { key: "id", sortable: true },
        { key: "image_url", sortable: false },
        { key: "extended", sortable: false },
        { key: "name", sortable: true },
        { key: "name_en", sortable: true },
        { key: "sort_order", sortable: true },
        { key: "actions", label: "", tdClass: "actions" }
      ],
      categoryModel: {},
      categoryModelChannels: {},
      order_update_id: null,
      perPage: 10,
      currentPage: 1,
      totalRows: 0
    };
  },
  computed: {
    hasUpdatePermissions: function() {
      return !!this.$storage
        .get("current_user")
        .permissions.filter(value => value == "categories:fully_manage").length;
    },
    hasReadPermissions: function() {
      return !!this.$storage
        .get("current_user")
        .permissions.filter(
          value =>
            value == "categories:fully_manage" || value == "categories:read"
        ).length;
    }
  },
  methods: {
    dataProvider(ctx) {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      // this.isBusy = true
      //console.log(ctx)
      let promise = this.$noname.get("categories", { params: ctx });

      return promise
        .then(data => {
          const items = data.data.items;
          this.totalRows = data.data.total;

          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          return items;
        })
        .catch(this.$noname.HandleError);
    },
    editRow(item, index, button) {
      this.categoryModel = Object.assign({}, item);
      this.$root.$emit("bv::show::modal", "categoryModalInfo", button);
    },
    viewChannels(item, index, button) {
      this.categoryModelChannels = Object.assign({}, item);
      this.$root.$emit("bv::show::modal", "modalChannels", button);
    },
    handleOk(evt) {
      if (
        this.categoryModel.image &&
        this.categoryModel.image.indexOf("data:image") == -1
      ) {
        this.categoryModel.image = null;
      }
      if (this.categoryModel.id > 0) {
        this.$noname
          .patch("categories", this.categoryModel.id, this.categoryModel)
          .then(response => {
            this.$root.$emit("bv::refresh::table", "category-table");
            this.$root.$emit("bv::hide::modal", "categoryModalInfo");
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Запись_успешно_сохранена"),
              type: "success"
            });
            //window.location.href = redirectUrl
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Ошибка_сохранения") + ":<br>" + error,
              type: "error"
            });
          });
      } else {
        this.$noname
          .post("categories", this.categoryModel)
          .then(response => {
            this.$root.$emit("bv::refresh::table", "category-table");
            this.$root.$emit("bv::hide::modal", "categoryModalInfo");
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Запись_успешно_сохранена"),
              type: "success"
            });

            //window.location.href = redirectUrl
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Ошибка_сохранения") + ":<br>" + error,
              type: "error"
            });
          });
      }
    },
    resetModal() {},
    addRow() {
      this.categoryModel = {};
      this.$root.$emit("bv::show::modal", "categoryModalInfo");
    },
    updateOrder(category) {
      this.order_update_id = category.id;
    },
    saveOrder(category) {
      if (category.sort_order === "" || isNaN(category.sort_order)) {
        Vue.notify({
          group: "notify",
          text: this.$i18n.t("message.Неверное_значение"),
          type: "warning"
        });
        return;
      }

      this.$noname
        .patch("categories", category.id, { sort_order: category.sort_order })
        .then(response => {
          this.order_update_id = null;
          this.$root.$emit("bv::refresh::table", "category-table");
          Vue.notify({
            group: "notify",
            text: this.$i18n.t("message.Порядок_сохранён"),
            type: "success"
          });
        })
        .catch(error => {
          Vue.notify({
            group: "notify",
            text: this.$i18n.t("message.Ошибка_сохранения") + ":<br>" + error,
            type: "error"
          });
        });
    },
    deleteRow(item, index, button) {
      this.$dialog
        .confirm(this.$i18n.t("message.Действительно_удалить_категорию?"))
        .then(response => {
          this.$noname
            .delete("categories", item.id)
            .then(response => {
              this.$root.$emit("bv::refresh::table", "category-table");
              Vue.notify({
                group: "notify",
                text: this.$i18n.t("message.Запись_успешно_удалена"),
                type: "success"
              });

              //window.location.href = redirectUrl
            })
            .catch(error => {
              Vue.notify({
                group: "notify",
                text:
                  this.$i18n.t("message.Ошибка_удаления_записи") +
                  ":<br>" +
                  error,
                type: "error"
              });
            });
        });
    }
  },
  directives: { debounce, focus }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/modules/Categories.vue